@if (!!chatId) {
  <div class="messages"
       cdkScrollable
       [class.thread]="isThread"
       (scroll)="onScroll()">

    <ng-content></ng-content>

    <div class="empty-space-if-no-scroll"></div>

    @for (message of items; track message.id; let messageIndex = $index) {
      <app-chat-message [message]="message"
                        [userChatId]="chatId"
                        [userId]="profile.id"
                        [isThread]="isThread"
                        [showSender]="chatType === ConversationType.group && items[messageIndex - 1]?.sender.id !== message.sender.id"
                        [threadIsOpened]="threadIsOpened()"
                        (openMessageThread)="threadMessageSelect.emit($event)"
      ></app-chat-message>

      @if (shouldShowDayDivider(messageIndex) && !isThread) {
        <div class="day-divider">
          <div class="day-divider__line"></div>
          <span class="day-divider__label">{{ getDayLabel(message.created_at) }}</span>
          <div class="day-divider__line"></div>
        </div>
      }
    }

    @if (isLoading) {
      <app-thin-loader></app-thin-loader>
    }

    @if (isNoItems) {
      <app-empty-state-placeholder
        icon="assets/icons/chat-bubble-outline.svg"
        [size]="80"
        [showCircleBg]="true"
        [text]="null"
        [description]="'messageCenter.noMessagesYet' | translate"
        [showButton]="false">
      </app-empty-state-placeholder>
    }

    @if (isThread) {
      <app-chat-message [showDivider]="true"
                        [message]="threadMessage"
                        [userChatId]="threadMessage.chat"
                        [userId]="profile.id"
                        [isThread]="true"
      ></app-chat-message>
    }
  </div>
}
